import React from 'react';

export default function PinCodes({
  pickupPin = 'N/A',
  deliveryPin = 'N/A',
}: {
  pickupPin: string | number;
  deliveryPin: string | number;
}) {
  return (
    <div className="information__box">
      <span className="box__field">
        <h5>Pickup PIN:</h5>
        <h5>{pickupPin}</h5>
      </span>
      <span className="box__field hidden">
        <h5>Delivery PIN:</h5>
        <h5>{deliveryPin}</h5>
      </span>
    </div>
  );
}
